import React, { useRef } from "react";
import { Link } from "react-router-dom";
import emailjs from "emailjs-com";
import PageLayout from "../../ui/PageLayout";
import AccordionFAQ from "../../ui/AccordionFAQ";
import FadeIn from "../../ui/FadeIn";

const faqItems = [
  { question: "Who can join KU?", answer: "Anyone! Anyone who's interested in kindness." },
  {
    question: "Is there a minimum amount that's required for donations?",
    answer: "No. Whether it's a part of your monthly savings or your pocket money, we welcome & are grateful for every little/ major contribution(s) that you make.",
  },
  {
    question: "Can I donate my time instead of money?",
    answer: "Absolutely! Time, Money, Material &/or Energy; is acknowledged & appreciated by us, always. We'd love to have you on board.",
  },
  {
    question: "What will I get in return for volunteering my services at KU?",
    answer: "100% Self-satisfaction, a sense of gratitude & a kinder version of you!! Also, acknowledgement certificates for the services rendered.",
  },
  {
    question: "I'm raising money for a social cause happening in my city. Will KU help me do so too?",
    answer: "We're open to discussions. Pitch us your proposal at contactus@kindnessunlimited.in",
  },
];

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("service_s3p4bs9", "template_0mn3b5m", e.target, "sxNZPEOtLzIM0BOV_")
      .then(
        () => {},
        () => {}
      );
    e.target.reset();
    alert("Your form has been submitted, we will get back to you later.");
  };

  return (
    <PageLayout>
      <AccordionFAQ
        title="At KU, No Question Is An 'Unkind' Question"
        subtitle={
          <>
            But first, <span className="line-through">COFFEE</span>{" "}
            <span className="text-ku-violet font-semibold">FAQs!</span>
          </>
        }
        items={faqItems}
      />

      <section className="ku-section bg-ku-gradient-soft">
        <div className="ku-container max-w-2xl">
          <FadeIn>
            <h2 className="ku-heading-lg text-center mb-3">Contact Us</h2>
            <p className="text-center text-gray-600 font-body text-lg mb-2">
              Have a different ask, message, suggestion or proposal?
            </p>
            <p className="text-center text-gray-600 font-body mb-8">
              Reach out to us at{" "}
              <a href="mailto:contactus@kindnessunlimited.in" className="text-ku-violet font-semibold">
                contactus@kindnessunlimited.in
              </a>
              <br />
              <Link to="/opportunities" className="text-ku-violet font-semibold hover:underline mt-2 inline-block">
                Click here if you are willing to volutneer or work with us
              </Link>
            </p>
          </FadeIn>

          <FadeIn delay={0.1}>
            <div className="ku-glass rounded-ku-lg p-8 md:p-10">
              <h3 className="font-display text-2xl font-bold text-ku-royal mb-2 text-center">In a hurry?</h3>
              <p className="text-center text-gray-600 mb-8">No worries! Drop-in your message here</p>
              <form ref={form} onSubmit={sendEmail} className="space-y-5">
                <div>
                  <label htmlFor="name" className="sr-only">Name</label>
                  <input
                    id="name"
                    name="name"
                    placeholder="Name"
                    type="text"
                    required
                    className="w-full px-4 py-3.5 rounded-ku border border-ku-soft bg-white font-body focus:outline-none focus:border-ku-violet min-h-[48px]"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="sr-only">Email</label>
                  <input
                    id="email"
                    name="email"
                    placeholder="Email Address"
                    type="email"
                    required
                    className="w-full px-4 py-3.5 rounded-ku border border-ku-soft bg-white font-body focus:outline-none focus:border-ku-violet min-h-[48px]"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="sr-only">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Message"
                    required
                    rows={5}
                    className="w-full px-4 py-3.5 rounded-ku border border-ku-soft bg-white font-body focus:outline-none focus:border-ku-violet resize-none"
                  />
                </div>
                <button type="submit" className="ku-btn-primary w-full">
                  Submit
                </button>
              </form>
            </div>
          </FadeIn>
        </div>
      </section>
    </PageLayout>
  );
};

export default ContactUs;
